// extracted by mini-css-extract-plugin
export var eyebrow = "_c1-3";
export var heroImage = "_c1-4";
export var main = "_c1-2";
export var modal = "_c1-0";
export var shell = "_c1-1";